import { Switch } from "@headlessui/react";
import React from "react";
import { twMerge } from "tailwind-merge";

import { GoalStatusLabel } from "@pages/ClinicalReportDetails/SelectProgramming/GoalStatusLabel";
import { TargetToggleState } from "@pages/ClinicalReportDetails/SelectProgramming/useSelectProgramming";

interface EhrTargetRowProps {
  target: TargetToggleState;
  onToggle: () => void;
}

export const EhrTargetRow: React.FC<EhrTargetRowProps> = ({ target, onToggle }) => {
  return (
    <div className="flex items-center py-2 pl-6 pr-0">
      <Switch
        checked={target.checked}
        onChange={onToggle}
        disabled={target.disabled}
        className={twMerge(
          "relative inline-flex h-4 w-[30px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-hidden focus:ring-2 focus:ring-green-600 focus:ring-offset-2",
          target.checked ? "bg-green-700" : "bg-gray-200",
          target.disabled && "cursor-not-allowed opacity-60",
        )}
        aria-label={target.checked ? "Exclude target" : "Include target"}
        aria-describedby={`target-title-${target.targetId}`}
      >
        <span
          className={twMerge(
            "pointer-events-none inline-block h-3 w-3 transform rounded-full bg-white shadow-sm ring-0 transition duration-200 ease-in-out",
            target.checked ? "translate-x-[14px]" : "translate-x-0",
          )}
        />
      </Switch>
      <span
        id={`target-title-${target.targetId}`}
        className="ml-3 flex-1 text-sm text-text-secondary truncate ph-no-capture"
      >
        {target.title}
      </span>
      <GoalStatusLabel status={target.status} className="ml-2 shrink-0" />
    </div>
  );
};
